var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { ButtonGroup } from "@atlaskit/button";
import { RadioGroup } from "@atlaskit/radio";
import { Button, Form, Grid, GridColumn, RightDiv, TextArea, TextField } from "@atlassiansox/microscopekit";
import { isQueueUrlValid, isRequestDataInputValid } from "../../models/Premise";
import { PremiseType } from "../../../__generated__/graphql-global-types";
import { parseInputNumber } from "../../utils/Utils";
import { JsonInput } from "../JsonInput";
import { LabelWithHelperText } from "../LabelWithHelperText";
import { NumberField } from "./common";
import { validators } from "../../utils";
import { useSendScreenEvent } from "../../analytics";
import { RepoValidationMessage } from "../RepoValidationMessage";
export var PremiseEditor = function (_a) {
    var _b, _c;
    var premise = _a.premise, setPremise = _a.setPremise, onCancel = _a.onCancel, onSubmit = _a.onSubmit;
    useSendScreenEvent("createWargamePlanPremiseEditorStep");
    if (!premise) {
        return null;
    }
    var setInputType = function (inputType) {
        return setPremise(function (prev) { return (!prev ? prev : __assign(__assign({}, prev), { inputType: inputType })); });
    };
    var setInputDataField = function (field) { return function (val) {
        return setPremise(function (prev) {
            var _a;
            return !prev
                ? prev
                : __assign(__assign({}, prev), { inputData: __assign(__assign({}, prev.inputData), (_a = {}, _a[field] = val, _a)) });
        });
    }; };
    var setApis = setInputDataField("apis");
    var setRepo = setInputDataField("repo");
    var setBranch = setInputDataField("branch");
    var setScriptName = setInputDataField("script_name");
    var setUserCount = setInputDataField("user_count");
    var setRampUpTime = setInputDataField("ramp_up_time");
    var setSteadyStateTime = setInputDataField("steady_state_time");
    var setQueueUrl = setInputDataField("queue_url");
    var setRequestData = setInputDataField("request_data");
    var setRequestMethod = setInputDataField("request_method");
    var setCustomEnvVaraibles = setInputDataField("custom_env_variables");
    var isQueueUrlVisible = isQueueUrlValid(premise.inputType);
    var isRequestDataInputVisible = isRequestDataInputValid(premise);
    return (React.createElement(Form, { onSubmit: onSubmit },
        React.createElement("label", null,
            React.createElement(LabelWithHelperText, { helperText: "The type of input to your perfhammer test", label: "Premise Type", insideHeader: true }),
            React.createElement(RadioGroup, { options: [
                    {
                        label: "APIs",
                        value: PremiseType.perfhammer_apis
                    },
                    {
                        label: "Scripts",
                        value: PremiseType.perfhammer_scripts
                    },
                    {
                        label: "SQS",
                        value: PremiseType.perfhammer_sqs
                    }
                ], name: "inputType", value: premise.inputType, onChange: function (event) {
                    setInputType(event.target.value);
                }, isRequired: true })),
        premise.inputType === PremiseType.perfhammer_apis && (React.createElement(React.Fragment, null,
            React.createElement("br", null),
            React.createElement("label", null,
                React.createElement(LabelWithHelperText, { helperText: "The HTTP method for the API request", label: "Request method", insideHeader: true }),
                React.createElement(RadioGroup, { options: [
                        {
                            label: "GET",
                            value: "GET"
                        },
                        {
                            label: "POST",
                            value: "POST"
                        },
                        {
                            label: "PUT",
                            value: "PUT"
                        }
                    ], name: "requestMethod", value: premise.inputData.request_method, onChange: function (event) {
                        setRequestMethod(event.target.value);
                    }, isRequired: true })),
            React.createElement("br", null),
            React.createElement(TextArea, { name: "apis", label: "Perfhammer APIs (In CSV format)", placeholder: "https://todo-backend.us-east-1.staging.atl-paas.net/projects," +
                    "https://todo-backend.us-east-1.staging.atl-paas.net/projects/1," +
                    "https://todo-backend.us-east-1.staging.atl-paas.net/projects/1/tasks", minimumRows: 6, value: premise.inputData.apis, onChange: function (event) {
                    setApis(event.target.value);
                }, isRequired: true }))),
        premise.inputType === PremiseType.perfhammer_scripts && (React.createElement(Grid, { layout: "flex" },
            React.createElement(GridColumn, { medium: 4 },
                React.createElement(TextField, { name: "script_repo", value: premise.inputData.repo, onChange: function (event) {
                        setRepo(event.target.value);
                    }, label: React.createElement(LabelWithHelperText, { helperText: "Repo URL Format \n git@bitbucket.org:/<project>/<repository>.git", label: "Scripts Repo" }), placeholder: "git@bitbucket.org:atlassian/resilience-lg.git" }),
                premise.inputData.repo && (React.createElement(RepoValidationMessage, { repoName: premise.inputData.repo }))),
            React.createElement(GridColumn, { medium: 4 },
                React.createElement(TextField, { name: "script_branch", value: premise.inputData.branch, onChange: function (event) {
                        setBranch(event.target.value);
                    }, label: "Scripts Repo Branch", placeholder: "master", isRequired: true })),
            React.createElement(GridColumn, { medium: 4 },
                React.createElement(TextField, { name: "script_name", value: premise.inputData.script_name, label: "Script Name", placeholder: "Script Name", isRequired: true, onChange: function (event) {
                        setScriptName(event.target.value);
                    } })))),
        isQueueUrlVisible && (React.createElement(Grid, { layout: "flex" },
            React.createElement(GridColumn, { medium: 6 },
                React.createElement(TextField, { name: "queue_url", value: premise.inputData.queue_url, onChange: function (event) {
                        setQueueUrl(event.target.value);
                    }, label: "Queue URL", placeholder: "Queue URL", isRequired: true })))),
        isRequestDataInputVisible && (React.createElement(React.Fragment, null,
            React.createElement("br", null),
            React.createElement(JsonInput, { name: "requestData", value: premise.inputData.request_data, onChange: setRequestData, label: "Request Data", placeholder: '{ "foo": "bar" }', isRequired: true }))),
        React.createElement("h5", null, "Advanced Options"),
        React.createElement(Grid, { layout: "flex" },
            React.createElement(GridColumn, { medium: 4 },
                React.createElement(NumberField, { name: "num_users", label: React.createElement(LabelWithHelperText, { helperText: 'The total number of users you want to simulate at "maximum capacity of your perfhammer test. Refer http://go/perfhammer for more details', label: "No. of Users" }), value: premise.inputData.user_count, isRequired: true, validate: function () {
                        return validators.min(premise.inputData.user_count, 1);
                    }, onChange: setUserCount })),
            React.createElement(GridColumn, { medium: 4 },
                React.createElement(TextField, { name: "rampup_time", label: React.createElement(LabelWithHelperText, { helperText: "The amount of time PerfHammer should spend increasing the number of users from 0 to the specified maximum.", label: "Ramp-up time (secs)" }), value: (_b = premise.inputData.ramp_up_time) === null || _b === void 0 ? void 0 : _b.toString(), onChange: function (event) {
                        setRampUpTime(parseInputNumber(event));
                    } })),
            React.createElement(GridColumn, { medium: 4 },
                React.createElement(TextField, { name: "steadystate_time", label: React.createElement(LabelWithHelperText, { helperText: "The amount of time you want to spend running your perfhammer test at maximum capacity. Maximum steady state time is 3600 seconds (1 hour).", label: "Steady state time (secs)" }), value: (_c = premise.inputData.steady_state_time) === null || _c === void 0 ? void 0 : _c.toString(), onChange: function (event) {
                        setSteadyStateTime(parseInputNumber(event));
                    } }))),
        React.createElement(JsonInput, { name: "customEnvVariables", value: premise.inputData.custom_env_variables, onChange: setCustomEnvVaraibles, label: "Custom Environment Variables", placeholder: "{\n \"env1\":\"value1\",\n \"env2\":\"value2\"\n}" }),
        React.createElement("br", null),
        React.createElement(RightDiv, null,
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { onClick: onCancel }, "Cancel"),
                React.createElement(Button, { appearance: "primary", type: "submit" }, "Save")))));
};
